import React from "react";
import "./style/Dashboard.css";
import { LuAlertTriangle } from "react-icons/lu";

function DashboardSingleCard({ heading, IconComponent, count, totalCount, isActive, onClick, isAttentionRequired, isZero }) {
  const classes = [
    "db-card",
    isActive && "db-card--active",
    isAttentionRequired && "db-card--alert",
    isZero && !isActive && "db-card--zero",
  ].filter(Boolean).join(" ");

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
      aria-pressed={isActive}
    >
      <div className="db-card__top">
        <span className="db-card__icon">{IconComponent}</span>
        {isAttentionRequired && <LuAlertTriangle size={16} className="db-card__alert-icon" />}
      </div>
      <span className="db-card__label">{heading}</span>
      <div className="db-card__bottom">
        <span className="db-card__count">{count ?? "—"}</span>
        {totalCount != null && <span className="db-card__total">/ {totalCount}</span>}
      </div>
    </button>
  );
}

export default DashboardSingleCard;
